import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import endPoints from "../../shared/services/endPoints";
import api from "../../shared/services/api";


export const chat = createAsyncThunk(
  "stage-smart/generateImage",
  async (
    { inputValue, image, dimensions, chatId, setIsLoading, setChatId },
    thunkAPI
  ) => {
    try {
      const formData = new FormData();
      formData.append("prompt", inputValue);

      if (image) {
        formData.append("image", image);
        if (dimensions) {
          const size = `${dimensions.width}x${dimensions.height}`;
          formData.append("size", size);
        }
      }
      if (chatId) {
        formData.append("chatId", chatId);
      }

      const chatResponse = await api("post", endPoints.STAGE_SMART, formData, {}, {
        "Content-Type": "multipart/form-data",
      });

      if (chatResponse.success) {
        if (chatResponse.data.chatId) {
          setChatId(chatResponse.data.chatId);
        }
        return chatResponse.data;
      } else {
        return thunkAPI.rejectWithValue(chatResponse.message || "Unknown error occurred.");
      }
    } catch (error) {
      setIsLoading(false);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// export const chat = createAsyncThunk(
//   "stage-smart/generateImage",
//   async (
//     { inputValue, image, dimensions,chatId, setMessages, setIsLoading, setChatId },
//     thunkAPI
//   ) => {
//     try {
//       // Create FormData for handling file uploads
//       const formData = new FormData();
//       formData.append("prompt", inputValue);

//       // Only append image if it exists
//       if (image) {
//         formData.append("image", image);
//         // Only append size if dimensions exist
//         if (dimensions) {
//           const size = `${dimensions.width}x${dimensions.height}`;
//           formData.append("size", size);
//         }
//       }

//       // Include chatId in the request if available
//       if (chatId) {
//         formData.append("chatId", chatId);
//       }

//       // Use FormData in the API call
//       const chatResponse = await api("post", endPoints.STAGE_SMART, formData, {}, {
//           "Content-Type": "multipart/form-data",
//       });


//       console.log(`reponse`,chatResponse);

//       if (chatResponse.success) {
//         // If response includes a chatId, update it in the component state
//         if (chatResponse.data.chatId) {
//           setChatId(chatResponse.data.chatId);
//         }

//         setMessages((messages, lastMessage) => {
//           const updatedMessages = [...messages];
//           // If the last message is from the assistant, update its content
//           if (lastMessage && lastMessage.role === "assistant") {
//             updatedMessages[updatedMessages.length - 1] = {
//               role: "assistant",
//               content: chatResponse.data.response,
//             };
//           } else {
//             // Otherwise add a new assistant message
//             updatedMessages.push({
//               role: "assistant",
//               content: chatResponse.data.response,
//             });
//           }
//           return updatedMessages;
//         });
//         setIsLoading(false);
//         return chatResponse.data;
//       }
//     } catch (error) {
//       setIsLoading(false);
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

export const fetchChatHistory = createAsyncThunk(
  "stage-smart/fetchChatHistory",
  async (thunkAPI) => {
    const response = await api("get", endPoints.STAGE_SMART_HISTORY);
    return response.data;
  }
);

export const fetchChatById = createAsyncThunk(
  "stage-smart/fetchChatById",
  async (id) => {
    const response = await api("get", endPoints.ORDER_DETAILS + id);
    return response.data;
  }
);

// export const orderRework = createAsyncThunk(
//   "order/orderRework",
//   async ({ id, newRework, oldReworks, setVisible }, thunkAPI) => {
//     try {
//       thunkAPI.dispatch(showLoader());
//       const image = await uploadFile(newRework.beforeImage);
//       newRework.beforeImage = image.path;

//       const payload = {
//         ...oldReworks,
//         reWorks: [...(oldReworks?.reWorks || []), { ...newRework }],
//       };

//       const response = await api("post", endPoints.ORDER_REWORK + id, {
//         ...payload,
//       });

//       if (response.success) {
//         thunkAPI.dispatch(fetchOrderById(response.data._id));
//       }
//       setVisible(false);
//       thunkAPI.dispatch(hideLoader());
//       return response.data;
//     } catch (error) {
//       console.log(error);
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

const stageSmartSlice = createSlice({
  name: "stageSmart",
  initialState: {
    history: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatHistory.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchChatHistory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.history = action.payload;
      })
      .addCase(fetchChatHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      });
  },
});

export default stageSmartSlice.reducer;
